import React, { useEffect } from 'react';
import { deleteAllCookies } from '../../../utilities/cookieUtils';
import Config from '../../../Config';
import authenticationProvider from '../../../utilities/authentication/authenticationProvider';
import { clearHistory } from '../../../utilities/authentication/authenticationSlice';
import { connect } from 'react-redux';

const Logout = (props) => {

  useEffect(() => {
    deleteAllCookies();
    (async () => {
      props.clearHistory();
      await authenticationProvider.clearAuthenticationData();
      window.location.href = Config.staticWebSiteUrl;
    })();
  }, []);

  return (null);
};

const mapDispatchToProps = {
  clearHistory
};
const mapStateToProps = (state) => { return {} };

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
